import { Directive, ElementRef, HostListener, inject } from '@angular/core';
import { NavigateService } from '@app/services/navigate.service';


@Directive({
    selector: '[handleLinkClick]',
    standalone: false
})
export class NativeLinksClickDirective {
  private readonly el = inject(ElementRef<HTMLElement>);
  private readonly navigateService = inject(NavigateService);

  @HostListener('click', ['$event'])
  onClick(event: MouseEvent): void {
    const target = event.target as HTMLElement | null;

    if (!target) {
      return;
    }

    const anchor = target.closest('a') as HTMLAnchorElement | null;

    if (!anchor || !this.el.nativeElement.contains(anchor)) {
      return;
    }

    // block default browser navigation
    event.preventDefault();
    event.stopPropagation();

    const href = anchor.getAttribute('href')?.trim();

    if (!href) {
      return;
    }

    const targetAttr = anchor.getAttribute('target')?.trim();
    const anchorTarget = targetAttr === '_blank' ? '_blank' : '_self';
    this.navigateService.navigate(href, anchorTarget);
  }
}
